import { ts_Module } from "@/@client/Theasoft_DataClasses"

export const isArtisticModule = (m: ts_Module) =>
  m === "theaBallett" ||
  m === "theaChor" ||
  m === "theaDispo" ||
  m === "theaOrchester" ||
  m === "theaStatisterie"
